module.exports = __webpack_public_path__ + "img/download.c9204883.svg";